module.exports = __webpack_public_path__ + "img/LFrench CV Quentin VEILLAS.2fbf16ff.jpg";